(function () {
  'use strict';

  /* Mobile menu drawer */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-drawer-open'));
      if (d) { d.classList.add('is-open'); open.setAttribute('aria-expanded', 'true'); var f = d.querySelector('a,button'); if (f) f.focus(); }
    }
    if (close) {
      var dr = close.closest('.drawer');
      if (dr) { dr.classList.remove('is-open'); var t = document.querySelector('[data-drawer-open="' + dr.id + '"]'); if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); } }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    document.querySelectorAll('.filter[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* Close other filter dropdowns */
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('.filter') || !e.target.open) return;
    document.querySelectorAll('.filter[open]').forEach(function (d) { if (d !== e.target) d.removeAttribute('open'); });
  }, true);

  /* Sort select */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Product page */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var dataEl = pdp.querySelector('[data-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var form = pdp.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = pdp.querySelector('[data-price]');
    var btn = pdp.querySelector('[data-atc]');
    var btnLabel = btn && btn.getAttribute('data-label');
    var soldLabel = btn && btn.getAttribute('data-sold');
    var customNote = pdp.querySelector('[data-custom-note]');
    var customValue = pdp.getAttribute('data-custom-value');
    var msg = pdp.querySelector('[data-msg]');
    var waBtn = pdp.querySelector('[data-wa]');
    var mainImg = pdp.querySelector('[data-main-img]');

    var pricesEl = pdp.querySelector('[data-variant-prices]');
    var prices = {};
    try { prices = pricesEl ? JSON.parse(pricesEl.textContent) : {}; } catch (e) {}
    var sizeGroup = pdp.querySelector('[data-size-group]');
    var sizeErr = pdp.querySelector('[data-size-error]');
    function chosenSize() {
      var c = sizeGroup && sizeGroup.querySelector('[data-size-input]:checked');
      return c ? c.value : null;
    }

    function selected() {
      return Array.prototype.map.call(pdp.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function update() {
      if (!product) return;
      var opts = selected();
      var v = product.variants.find(function (x) {
        return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
      pdp.querySelectorAll('[data-option]').forEach(function (fs) {
        var l = fs.querySelector('[data-option-value]');
        var c = fs.querySelector('input:checked');
        if (l && c) l.textContent = c.value;
      });
      var size = chosenSize();
      if (sizeGroup) {
        var sv = sizeGroup.querySelector('[data-size-value]');
        if (sv && size) sv.textContent = size;
        if (size && sizeErr) sizeErr.hidden = true;
      }
      var isCustom = customValue && (opts.indexOf(customValue) !== -1 || size === customValue);
      if (customNote) customNote.hidden = !isCustom;
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = soldLabel; } return; }
      if (idInput) idInput.value = v.id;
      var pr = prices[String(v.id)];
      if (priceEl && pr) {
        priceEl.textContent = '';
        if (pr.c) { var s = document.createElement('s'); s.textContent = pr.c; priceEl.appendChild(s); }
        var sp = document.createElement('span'); sp.textContent = pr.p; priceEl.appendChild(sp);
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btnLabel : soldLabel; }
      if (v.featured_image && mainImg) { mainImg.src = v.featured_image.src; }
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      if (waBtn) {
        var base = waBtn.getAttribute('data-wa');
        var parts = opts.filter(function (o) { return o && o !== 'Default Title'; });
        if (size) parts.push(size);
        var text = waBtn.getAttribute('data-wa-text').replace('[SIZE]', parts.join(' / ') || '—');
        waBtn.href = base + '?text=' + encodeURIComponent(text + ' ' + window.location.href);
      }
    }
    pdp.addEventListener('change', function (e) { if (e.target.closest('[data-option]') || e.target.closest('[data-size-group]')) update(); });

    /* Gallery thumbs */
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-thumb'); mainImg.srcset = ''; }
        pdp.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });

    /* Ajax add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (sizeGroup && !chosenSize()) {
          if (sizeErr) sizeErr.hidden = false;
          sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = sizeGroup.querySelector('input'); if (first) first.focus({ preventScroll: true });
          return;
        }
        var measure = form.querySelector('[data-measure]');
        if (customNote && !customNote.hidden && measure && !measure.value.trim()) { measure.focus(); return; }
        if (btn) btn.disabled = true;
        if (msg) { msg.textContent = ''; msg.className = 'pdp-msg'; }
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message);
            if (msg) {
              msg.textContent = msg.getAttribute('data-ok') + ' ';
              var a = document.createElement('a'); a.href = msg.getAttribute('data-cart-url') || '/cart'; a.className = 'link-line'; a.textContent = msg.getAttribute('data-cart-label');
              msg.appendChild(a); msg.className = 'pdp-msg is-ok';
            }
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
            });
          })
          .catch(function (err) { if (msg) { msg.textContent = err.message; msg.className = 'pdp-msg is-error'; } })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    }

    /* Sticky add to cart on mobile */
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting); }).observe(btn);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
    update();
  }

  /* Dialogs (size chart) */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-dialog-open]');
    if (o) { var d = document.getElementById(o.getAttribute('data-dialog-open')); if (d && d.showModal) d.showModal(); }
    var c = e.target.closest('[data-dialog-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); }
    if (e.target.tagName === 'DIALOG') e.target.close();
    var u = e.target.closest('[data-unit]');
    if (u) {
      var chart = u.closest('[data-size-chart]');
      chart.querySelectorAll('[data-unit]').forEach(function (b) { var on = b === u; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
      chart.querySelectorAll('[data-unit-table]').forEach(function (t) { t.hidden = t.getAttribute('data-unit-table') !== u.getAttribute('data-unit'); });
    }
  });

  /* Recommend to a friend: native share when available */
  document.querySelectorAll('[data-share]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!navigator.share) return;
      e.preventDefault();
      navigator.share({ title: a.getAttribute('data-share-title'), text: a.getAttribute('data-share'), url: a.getAttribute('data-share-url') }).catch(function () {});
    });
  });

  /* Cart quantity buttons */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var v = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, v + (b.hasAttribute('data-plus') ? 1 : -1));
      input.form && input.form.submit();
    });
  });
})();
